import TableOnly from "components/DataTable/TableOnly";
import Pagination from "components/Pagination/Pagination";
import SearchComp from "components/SearchComp/SearchComp";
import Spinner from "components/Spinner";
import { setNotification } from "features/Notification/notificationSlice";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import authHeader from "services/auth-header";
import API from "services/axios";

let API_URL = "/get-device-logs/";
let COMPONENT_URL = "/attendance";
let COMPONENT_DETAILS_URL = "/testing-components";

let limits = [5, 10, 15, 20];

export default function DeviceLogs({ selectedDevice }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  /*   All States
   ********************************************* */
  const [deviceLogs, setDeviceLogs] = useState([]);
  const [searchResults, setSearchResults] = useState(null);

  const [totalPages, setTotalPages] = useState(
    parseInt(searchParams.get("totalPages")) || 1
  );

  if (searchParams.get("limit") === null) {
    setSearchParams((prev) => {
      let limit = prev.get("limit") || "10";
      const newParams = new URLSearchParams(prev);
      newParams.set("limit", limit);
      return newParams.toString();
    });
  }
  if (searchParams.get("page") === null) {
    setSearchParams((prev) => {
      let page = prev.get("page") || "1";
      const newParams = new URLSearchParams(prev);
      newParams.set("page", page);
      return newParams.toString();
    });
  }

  const [loading, setLoading] = useState(false);

  /*   All Functions
   ********************************************* */

  const changeLimit = (val) => {
    setSearchParams((prev) => {
      const newParams = new URLSearchParams(prev);
      newParams.set("limit", val);
      return newParams.toString();
    });
  };

  const getSearchParamsWithoutGivenKey = (key) => {
    let params = new URLSearchParams(searchParams);
    params.delete(key);

    return params.toString();
  };

  const getDeviceLogs = async () => {
    try {
      setLoading(true);

      let page = parseInt(searchParams.get("page")) || 1;
      let limit = parseInt(searchParams.get("limit")) || 10;
      let query = searchParams.get("query") || "";
      let filterBy = "all";

      let body = { page, limit, filterBy };

      if (query) {
        body.query = query;
      }

      const { data } = await API.post(API_URL + selectedDevice?.id, body, {
        headers: authHeader(),
      });
      if (data.success) {
        setDeviceLogs(data.data);
        setTotalPages(data.totalPages);
        setSearchResults(null);
      } else {
        dispatch(
          setNotification({
            message: data.message,
            type: "error",
          })
        );
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  const parsedRecordDate = (recordTime) => {
    const date = new Date(recordTime);
    return date.toUTCString().slice(0, 16);
  };

  const parsedRecordTime = (recordTime) => {
    const date = new Date(recordTime);

    // Use UTC methods to get the original time
    let hours = date.getUTCHours();
    let minutes = date.getUTCMinutes();

    const meridiem = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'

    minutes = minutes < 10 ? "0" + minutes : minutes;
    let strTime = hours + ":" + minutes + " " + meridiem;
    return strTime;
  };

  /*   All UseEffects
   ********************************************* */

  const table_head = [
    { name: "Uid", value: "userId" },
    { name: "User", value: "attendanceUser?.name" },
    { name: "Type", value: "isDeviceRecord" },
    { name: "Record Time", value: "recordTime" },
    { name: "Record Date", value: "recorddTime" },
  ];

  const table_body = (item, index) => (
    <tr className="" key={index}>
      <td className="py-1 me-0">{item?.userId}</td>
      <td className="py-1 me-0">{item?.attendanceUser?.name}</td>
      <td className="py-1 me-0">
        {item?.isDeviceRecord ? "Device" : "Manual"}
      </td>
      <td>{parsedRecordTime(item.recordTime)}</td>
      <td>{parsedRecordDate(item.recordTime)}</td>
    </tr>
  );

  useEffect(() => {
    let timeout = setTimeout(() => {
      if (!selectedDevice) {
        return;
      }
      getDeviceLogs();
    }, 50);
    return () => clearTimeout(timeout);
  }, [searchParams]);

  return (
    <div className="">
      {/* Table */}
      <div className="">
        <>
          <div className="">
            <div className="d-flex justify-content-end align-items-center mb-3">
              <div className="flex-grow-1 d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center gap-1">
                  <div>Show</div>
                  <button
                    className="px-1 bg-primary bg-opacity-10 border border-primary rounded-end rounded-start "
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {searchParams.get("limit")}
                  </button>
                  <ul
                    style={{ width: "fit-content" }}
                    className="dropdown-menu"
                  >
                    {limits.map((limit) => (
                      <li key={limit}>
                        <button
                          className="dropdown-item"
                          onClick={() => changeLimit(limit)}
                        >
                          {limit}
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              {/* <SearchComp
                setLoading={setLoading}
                apiPath={`${COMPONENT_URL}?`}
              /> */}
            </div>
            <div
              style={{
                height: "63vh",
                overflowY: "auto",
              }}
            >
              <TableOnly
                disableSorting={true}
                table_head={table_head}
                table_body={table_body}
                table_data={searchResults ? searchResults : deviceLogs}
                totalPages={totalPages}
              />
            </div>
            {loading && <Spinner />}
            {!searchResults && (
              <Pagination
                totalPages={totalPages}
                apiPath={`${COMPONENT_URL}${
                  searchParams.toString()
                    ? "?" + getSearchParamsWithoutGivenKey("page") + "&"
                    : "?"
                }page=`}
                currPage={parseInt(searchParams.get("page")) || 1}
              />
            )}
          </div>
        </>
      </div>
    </div>
  );
}
